export default "__VITE_ASSET__f0e47479__"